import { Component, Emit, Vue } from "vue-property-decorator";

@Component({})
export default class EnterNubiiAnimation extends Vue {
  activeEnterEffect(store = null) {
    this.$store = store ? store : this.$store;
    const audio = new Audio(require("@/assets/audio/enternubii.mp3"));
    audio.play();
    let add = 80;
    const interval = setInterval(async () => {
      await this.$store.dispatch("SystemStore/setZoomAction", add);
      await this.$store.dispatch("GraphicClientStore/setZoom", add);
      add--;
      if (add <= 25) clearInterval(interval);
    }, 20);
  }
}
